<template>
  <div class="content">
    <div class="content-main">
      <p class="content-title">用户名单</p>
      <div class="content-input">
        <div class="content-input-item">
          <AreaMultiple title="现居城市：" @areaChang='getNowArea($event)' :reset="resetArea"/>
        </div>
        <div class="content-input-item">
          <label>性别：</label>
          <el-select v-model="sex" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in sexArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>身份认证总状态：</label>
          <el-select v-model="overallAuthState" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in overallAuthStateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>婚姻状态：</label>
          <el-select v-model="marryState" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in marryStateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>期望结婚时间：</label>
          <el-select v-model="marryTime" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in marryTimeArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>学历：</label>
          <el-select v-model="education" placeholder="Select" style="width: 11em" multiple collapse-tags @change="educationChange">
            <el-option v-for="item in educationArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>月收入：</label>
          <el-select v-model="salaryMin" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in salaryMinArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
          &nbsp;-&nbsp;
          <el-select v-model="salaryMax" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in salaryMaxArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>身高：</label>
          <el-select v-model="heightMin" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in heightMinArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
          &nbsp;-&nbsp;
          <el-select v-model="heightMax" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in heightMaxArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>体重：</label>
          <el-select v-model="weightMin" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in weightMinArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
          &nbsp;-&nbsp;
          <el-select v-model="weightMax" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in weightMaxArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>子女情况：</label>
          <el-select v-model="childState" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in childStateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>父母情况：</label>
          <el-select v-model="parentState" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in parentStateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <NativeArea title="籍贯地址：" @areaChang='getNativeArea($event)' :reset="resetArea"/>
        </div>
        <div class="content-input-item">
          <label>微信认证总状态：</label>
          <el-select v-model="wechatTotalState" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in wechatTotalStateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>通过码：</label>
          <el-select v-model="throughCode" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in throughCodeArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>认证情况：</label>
          <el-select v-model="authState" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in authStateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>进入情况：</label>
          <el-select v-model="enterState" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in enterStateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <Area title="家乡城市：" @areaChang='getArea($event)' :reset="resetArea"/>
        </div>
        <div class="content-input-item">
          <label>信息审核状态：</label>
          <el-select v-model="resumeState" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in resumeStateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <DatePickerRange title="注册时间：" @date="getTime($event)" @check="getCheck($event)" :isChecked="isChecked"/>
        </div>
        <div class="content-input-item">
          <DatePickerRange title="登录时间：" @date="getLoginTime($event)" @check="getLoginCheck($event)" :isChecked="isLoginChecked"/>
        </div>
        <div class="content-input-item">
          <label>跟进人：</label>
          <el-select v-model="userCustomerServiceState" placeholder="Select" style="width: 6.4em" @change="changeUserCustomer">
            <el-option v-for="item in userCustomerServiceStateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
          <span v-show="userCustomerServiceState == 1">&nbsp;-&nbsp;</span>
          <el-select v-show="userCustomerServiceState == 1" v-model="wechatId" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in wechatIdArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <DatePickerRange title="跟进时间：" @date="getCustomerTime($event)" @check="getCustomerCheck($event)" :isChecked="isCustomerChecked" :disable="customerDisable"/>
        </div>
        <div class="content-input-item">
          <el-select v-model="ageType" placeholder="Select" style="width: 8em; margin-right: 4px;" @change="ageTypeChange">
            <el-option v-for="item in ageTypeArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
          <el-select v-show="ageType == 1" v-model="ageGroup" placeholder="Select" style="width: 8em" @change="ageGroupChange">
            <el-option v-for="item in ageGroupArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
          <DatePickerRange v-show="ageType == 2"  title="" @date="getBirthdayTime($event)" @check="getBirthdayCheck($event)" :isChecked="isBirthdayChecked"/>
          <div v-show="ageType == 3" >
            <el-input type="search" v-model="startAge" placeholder="最小年龄" :maxlength="2" style="width: 7em" @change="startAgeChange"/>
            &nbsp;-&nbsp;
            <el-input type="search" v-model="endAge" placeholder="最大年龄" :maxlength="2" style="width: 7em" @change="endAgeChange"/>
          </div>
        </div>
        <div class="content-input-item">
          <label>是否邀请制用户：</label>
          <el-select v-model="inviteSpecialState" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in inviteSpecialStateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <SearchComponents :searchValue="searchValue" :searchTypeList="searchTypeArray" :searchType="searchType"  @searchType="getSearchType($event)" @searchValue="getSearchValue($event)" />
          <el-checkbox v-model="limitState" style="margin-left: 8px;">有限制</el-checkbox>
        </div>
        <div class="content-input-item">
          <ElButtons type="primary" icon="search" @click="getPage(true)"> 查询 </ElButtons>
          <ElButtons icon="RefreshLeft" @click="refreshParam"> 重置 </ElButtons>
        </div>
      </div>
    </div>
    <div class="content-main">
      <div class="content-button">
        <div>
          <!--          <el-button type="primary" v-loading="updateLoading" @click="updateInteract">标为已审查</el-button>-->
          <p style="font-weight: bold;">共 {{ totalRow }} 条</p>
        </div>
        <BtnGroup :tableRef="$refs.multipleTableRef" :colList="colList" @colListChange="colListChange($event)" @refresh="getPage"></BtnGroup>
      </div>
      <div class="content-table">
        <el-table
            ref="multipleTableRef"
            :data="pageDataList"
            style="width: 100%"
            border
            @cell-click="toggleSelection"
            @selection-change="selsChange"
            @header-click="selsAll"
            v-loading="listLoading"
            @sort-change="sortChange"
        >
          <!--          <el-table-column type="selection" width="40" align="center" class-name="cursor"/>-->
          <el-table-column property="createTime" label="注册时间" v-if="checkColList.indexOf('注册时间') > -1" width="106" sortable='custom'/>
          <el-table-column property="loginTime"  label="登陆时间" v-if="checkColList.indexOf('登陆时间') > -1" width="106" sortable='custom'/>
          <el-table-column property=""  label="手持身份照片" v-if="checkColList.indexOf('手持身份照片') > -1" width="192" >
            <template #default="scope">
              <el-space>
                <div v-if="scope.row.identityAuth.imgF"><GetPlain :side="0" :url="scope.row.identityAuth.imgF" :uid="scope.row.uid" :type="12" :subType="0"/></div>
                <div v-if="scope.row.identityAuth.imgZ"><GetPlain :side="1" :url="scope.row.identityAuth.imgZ" :uid="scope.row.uid" :type="12" :subType="0"/></div>
              </el-space>
            </template>
          </el-table-column>
          <el-table-column label="头像" v-if="checkColList.indexOf('头像') > -1" width="106">
            <template #default="scope">
              <div v-if="scope.row.headImg.smallHeadImg"><el-image style="width: 80px; height: 80px" :src="scope.row.headImg.smallHeadImg" @click="userInfoDialog(scope.row)" class="cursor"><template #error><div class="el-img-error">暂无图片</div></template></el-image></div>
            </template>
          </el-table-column>
          <el-table-column label="用户信息" v-if="checkColList.indexOf('用户信息') > -1" width="200">
            <template #default="scope">
              <UserInfoList :row="scope.row" showList="name,phone,uid,city,birth" :from="1"/>
            </template>
          </el-table-column>
          <el-table-column property="" label="小记" v-if="checkColList.indexOf('小记') > -1" width="164" class-name="cursor">
            <template #default="scope">
              <UserRemark :user-remark-list="scope.row.userSmallRemarkList" />
            </template>
          </el-table-column>
          <el-table-column property="" label="跟进人" v-if="checkColList.indexOf('跟进人') > -1" width="106">
            <template #default="scope">
              <p>{{scope.row.customerServiceState == 0 ? '未添加' : scope.row.customerServiceState == 1 ? '已添加' : scope.row.customerServiceState == 2 ? '已删除' : ''}}</p>
              <p v-if="scope.row.customerServiceState == 1">({{scope.row.wechatId}})</p>
              <p v-if="scope.row.customerServiceState == 1">{{scope.row.customerServiceTime}}</p>
              <el-button style="margin-top: 8px;" type="primary" size="small" @click="editCustomer(scope.row)">编辑</el-button>
            </template>
          </el-table-column>
          <el-table-column property="" label="基本信息" v-if="checkColList.indexOf('基本信息') > -1" width="140">
            <template #default="scope">
              <p>婚姻状态：{{scope.row.marryState == 1 ? '未婚' : scope.row.marryState == 2 ? '离异' : scope.row.marryState == 3 ? '丧偶' : ''}}</p>
              <p>月收入：{{scope.row.salaryMin == -1 ? '不限' : scope.row.salaryMin}}-{{scope.row.salaryMax == -1 ? '不限' : scope.row.salaryMax + 'k'}}</p>
<!--              <p>学历：<span v-if="scope.row.authEdu">{{scope.row.authEdu.education? educationArray[scope.row.authEdu.education].label : ''}}</span></p>-->
              <p>学历：{{scope.row.education? educationArray[scope.row.education].label : ''}}</p>
              <p>行业|职能: <span v-if="scope.row.authJob">{{scope.row.authJob.profession}}<span v-if="scope.row.authJob.profession">|</span>{{scope.row.authJob.function}}</span></p>
              <p>职位: <span v-if="scope.row.authJob">{{scope.row.authJob.position}}</span></p>
            </template>
          </el-table-column>
          <el-table-column property="" label="择偶标准" v-if="checkColList.indexOf('择偶标准') > -1" width="150">
            <template #default="scope">
              <p>身高：<span v-if="scope.row.spouse">{{scope.row.spouse.heightMin == -1 ? '不限' : scope.row.spouse.heightMin}}-{{scope.row.spouse.heightMax == -1 ? '不限' : scope.row.spouse.heightMax + 'cm'}}</span></p>
              <p>婚姻状态：<span v-if="scope.row.spouse">{{scope.row.spouse.marryState == 1 ? '未婚' : scope.row.spouse.marryState == 2 ? '离异' : scope.row.spouse.marryState == 3 ? '丧偶' : ''}}</span></p>
              <p>月收入：<span v-if="scope.row.spouse">{{scope.row.spouse.salaryMin == -1 ? '不限' : scope.row.spouse.salaryMin}}-{{scope.row.spouse.salaryMax == -1 ? '不限' : scope.row.spouse.salaryMax + 'k'}}</span></p>
              <p>学历：<span v-if="scope.row.spouse">{{scope.row.spouse.educationMin ? scope.row.spouse.educationMin == -1 ? '不限' : educationArray[scope.row.spouse.educationMin].label : ''}}-{{scope.row.spouse.educationMax ? scope.row.spouse.educationMax  == -1 ? '不限' : educationArray[scope.row.spouse.educationMax].label : ''}}</span></p>
            </template>
          </el-table-column>
          <el-table-column label="用户日志" v-if="checkColList.indexOf('用户日志') > -1" class-name="cursor" width="164">
            <template #default="scope">
              <UserLog :user-log-list="scope.row.userLogList" />
            </template>
          </el-table-column>
          <el-table-column property="" label="信息审核状态" v-if="checkColList.indexOf('信息审核状态') > -1" width="110">
            <template #default="scope">
              <p>{{scope.row.resumeState == 0 ? '未提交' : scope.row.resumeState == 1 ? '待审核' : scope.row.resumeState == 2 ? '审核通过' : scope.row.resumeState == 3 ? '审核不通过' : '--'}}</p>
            </template>
          </el-table-column>
          <el-table-column property="pdesc" label="自我介绍" v-if="checkColList.indexOf('自我介绍') > -1" width="120"/>
          <el-table-column property="" label="信息标签" v-if="checkColList.indexOf('信息标签') > -1" width="170">
            <template #default="scope">
              <div v-if="scope.row.userTagList">
                <p class="tag-title">关于我：</p>
                <el-tag class="tap-item" v-for="(item,index) in scope.row.userTagListMe" size="small" effect="plain" :key="index" type="info">{{item.tag}}</el-tag>
                <p class="tag-title">理想的Ta：</p>
                <el-tag class="tap-item" v-for="(item,index) in scope.row.userTagListTa" size="small" effect="plain" :key="index" type="info">{{item.tag}}</el-tag>
              </div>
            </template>
          </el-table-column>
          <el-table-column property="" label="认证情况" v-if="checkColList.indexOf('认证情况') > -1" width="150">
            <template #default="scope">
              <p v-if="scope.row.authHouse && scope.row.authHouse.houseState != 0">
                房屋认证：
                <span v-if="scope.row.authHouse">
                  {{
                    scope.row.authHouse.houseState == 0 ? '未提交' :
                    scope.row.authHouse.houseState == 1 ? '未认证' :
                    scope.row.authHouse.houseState == 2 ? scope.row.authHouse.city :
                    scope.row.authHouse.houseState == 3 ? '认证失败' : ''
                  }}
                </span>
              </p>
              <p v-if="scope.row.authJob && scope.row.authJob.jobState != 0">
                职业认证：
                <span v-if="scope.row.authJob">
                  {{
                    scope.row.authJob.jobState == 0 ? '未提交' :
                    scope.row.authJob.jobState == 1 ? '未认证' :
                    scope.row.authJob.jobState == 2 ? scope.row.authJob.position :
                    scope.row.authJob.jobState == 3 ? '认证失败' : ''
                  }}
                </span>
              </p>
              <p v-if="scope.row.authEdu && scope.row.authEdu.eduState != 0">
                学历认证：
                <span v-if="scope.row.authEdu">
                  {{
                    scope.row.authEdu.eduState == 0 ? '未提交' :
                    scope.row.authEdu.eduState == 1 ? '未认证' :
                    scope.row.authEdu.eduState == 2 ? (scope.row.authEdu.education?educationArray[scope.row.authEdu.education].label + '-' + scope.row.authEdu.schoolName:'') :
                    scope.row.authEdu.eduState == 3 ? '认证失败' : ''
                  }}
                </span>
              </p>
              <p v-if="scope.row.authCar && scope.row.authCar.carState != 0">
                车辆认证：
                <span v-if="scope.row.authCar">
                  {{
                    scope.row.authCar.carState == 0 ? '未提交' :
                    scope.row.authCar.carState == 1 ? '未认证' :
                    scope.row.authCar.carState == 2 ? scope.row.authCar.carName :
                    scope.row.authCar.carState == 3 ? '认证失败' : ''
                  }}
                </span>
              </p>
              <p v-if="scope.row.authVideo">
                视频认证：
                {{
                  scope.row.authVideo.state == 1 ? '未认证' :
                  scope.row.authVideo.state == 2 ? '已认证' :
                  scope.row.authVideo.state == 3 ? '认证失败' : '未提交'
                }}
              </p>
            </template>
          </el-table-column>
          <el-table-column property="" label="身份认证总状态" v-if="checkColList.indexOf('身份认证总状态') > -1" width="124">
            <template #default="scope">
              <div>
                {{
                  scope.row.identityAuth.overallAuthState == 0 ? '未认证' :
                  scope.row.identityAuth.overallAuthState == 1 ? '申请认证' :
                  scope.row.identityAuth.overallAuthState == 2 ? '' :
                  scope.row.identityAuth.overallAuthState == 3 ? '认证不通过' :
                  scope.row.identityAuth.overallAuthState == 4 ? '正面不通过' :
                  scope.row.identityAuth.overallAuthState == 5 ? '反面不通过' : ''
                }}
              </div>
              <div v-if="scope.row.identityAuth.overallAuthState == 2">
                <p>姓名：{{scope.row.identityAuth.identityName}}</p>
                <p>身份证号：{{scope.row.identityAuth.identityCode}}</p>
              </div>
            </template>
          </el-table-column>
          <el-table-column property="" label="微信认证总状态" v-if="checkColList.indexOf('微信认证总状态') > -1" width="124">
            <template #default="scope">
<!--              <el-image v-if="scope.row.wechatTotalState == 2" style="width: 80px; height: 80px" :src="scope.row.wechatImg" @click="showImg(scope.row.wechatImg)" class="cursor"><template #error><div class="el-img-error">暂无图片</div></template></el-image>-->
              <GetPlain v-if="scope.row.wechatTotalState == 2" :url="scope.row.wechatImg" :uid="scope.row.uid" :type="11" :subType="0"/>
              <p v-else>
                {{
                  scope.row.wechatTotalState == 0 ? '未提交' :
                  scope.row.wechatTotalState == 1 ? '待审核' :
                  scope.row.wechatTotalState == 2 ? '已通过' :
                  scope.row.wechatTotalState == 3 ? '未通过' : '--'
                }}
              </p>
              <div v-show="scope.row.isUse == 1">
                <p>通过码：{{scope.row.throughCode}}</p>
                {{scope.row.wechatTotalState == 2 ? '已通过' : scope.row.wechatTotalState == 3 ? '未通过' : '--'}}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="微信信息" v-if="checkColList.indexOf('微信信息') > -1" width="106">
            <template #default="scope">
              <div style="display: flex; flex-direction: column;align-items: center; text-align: center">
                <div v-if="scope.row.inviteSpecialWechatInfo"><el-image style="width: 80px; height: 80px" :src="scope.row.inviteSpecialWechatInfo.headImgUrl" class="cursor" @click="showImg(scope.row.inviteSpecialWechatInfo.headImgUrl)"><template #error><div class="el-img-error">暂无图片</div></template></el-image></div>
                <p v-if="scope.row.inviteSpecialWechatInfo" style="font-weight: bold">{{scope.row.inviteSpecialWechatInfo.nickName}}</p>
                <p>{{scope.row.inviteSpecialTime}}</p>
              </div>

            </template>
          </el-table-column>
          <el-table-column property="" label="通过码处展示红娘" v-if="checkColList.indexOf('通过码处展示红娘') > -1" width="140">
            <template #default="scope">
              <div v-if="scope.row.throughCodeMarriageWechat">
                <p>{{scope.row.throughCodeMarriageWechat.wechatName}}</p>
                <p>{{scope.row.throughCodeMarriageWechat.wechatNum}}</p>
              </div>
            </template>
          </el-table-column>
          <el-table-column property="" label="牵线处展示红娘" v-if="checkColList.indexOf('牵线处展示红娘') > -1" width="124" >
            <template #default="scope">
              <div v-if="scope.row.marriageWechat">
                <p>{{scope.row.marriageWechat.wechatName}}</p>
                <p>{{scope.row.marriageWechat.wechatNum}}</p>
              </div>
            </template>
          </el-table-column>
          <el-table-column property="" label="操作" v-if="checkColList.indexOf('操作') > -1">
            <template #default="scope">
              <el-button type="success" size="small" v-loading="scope.row.delLoading" @click="updateResumeDelState(scope.$index, scope.row, 0)" v-if="scope.row.isDel==1">取消隐藏</el-button>
              <el-button type="primary" size="small" v-loading="scope.row.delLoading" @click="updateResumeDelState(scope.$index, scope.row, 1)" v-if="scope.row.isDel==0">隐藏</el-button>
            </template>
          </el-table-column>

        </el-table>
        <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import DatePickerRange from '../../components/DatePickerRange'
import SearchComponents from '../../components/SearchComponents'
import BtnGroup from '../../components/BtnGroup'
import { getUserPageList, getCommonSysParam, updateResumeDelState } from '../../api/url'
import {getFormData, postFormData} from '../../api/api'
import Dialog from '../../assets/js/dialog'
import UserLogDialog from '../../components/UserLog/UserLogDialog'
import ImgViewer from '../../assets/js/imageViewer'
import { common } from "@/assets/shared/select-constant";
import UserLog from "@/components/UserLog/UserLog";
import UserRemark from "@/components/Remark/UserRemark";
import UserRemarkDialog from "@/components/Remark/UserRemarkDialog";
import GreetingDateNum from "@/views/greeting/components/GreetingDateNum";
import Area from '@/components/Area'
import AreaMultiple from '@/components/AreaMultiple'
import NativeArea from '@/components/NativeAreaMultiple'
import updateCustomerDialog from "@/views/user/components/updateCustomerDialog";
import GetPlain from "@/components/resume/GetPlain";
import userListInfoDialog from "@/components/resume/userListInfoDialog";

export default {
  name: "UserList",
  components: { DatePickerRange, SearchComponents, BtnGroup, UserLog, Area, NativeArea, UserRemark, GetPlain, AreaMultiple },
  data() {
    return {

      sexArray: common.sexList,
      sex: common.sexList[2]['value'],

      //身份认证
      overallAuthStateArray: [
        {label: '不限', value: -1},
        {label: '未认证未提交', value: 0},
        {label: '申请认证', value: 1},
        {label: '已认证', value: 2},
        {label: '认证不通过', value: 3},
      ],
      overallAuthState: -1,

      // 婚姻状态
      marryStateArray: [
        {label: '不限', value: -1},
        {label: '未婚', value: 1},
        {label: '离异', value: 2},
        {label: '丧偶', value: 3},
      ],
      marryState: -1,

      // 期望结婚时间
      marryTimeArray: [
        {label: '不限', value: -1},
        {label: '半年内', value: 1},
        {label: '一年内', value: 2},
        {label: '两年内', value: 3},
        {label: '三年内', value: 4},
      ],
      marryTime: -1,

      // 学历
      educationArray: [
        {label: '不限', value: -1},
        {label: '初中', value: 1},
        {label: '中专/职高/技校', value: 2},
        {label: '高中', value: 3},
        {label: '大专', value: 4},
        {label: '本科', value: 5},
        {label: '硕士', value: 6},
        {label: '博士', value: 7},
        {label: '博士后', value: 8}
      ],
      education: [-1],

      // 月收入
      salaryMinArray: [
        {label: '不限', value: -1}
      ],
      salaryMin: -1,
      salaryMaxArray: [
        {label: '不限', value: -1}
      ],
      salaryMax: -1,

      // 身高
      heightMinArray: [
        {label: '不限', value: -1}
      ],
      heightMin: -1,
      heightMaxArray: [
        {label: '不限', value: -1}
      ],
      heightMax: -1,

      // 体重
      weightMinArray: [
        {label: '不限', value: -1}
      ],
      weightMin: -1,
      weightMaxArray: [
        {label: '不限', value: -1}
      ],
      weightMax: -1,

      // 子女情况
      childStateArray: [
        {label: '不限', value: -1},
        {label: '没有', value: 1},
        {label: '有.和我住一起', value: 2},
        {label: '有.有时和我住一起', value: 3},
        {label: '有.不和我住一起', value: 4},
      ],
      childState: -1,

      // 父母情况
      parentStateArray: [
        {label: '不限', value: -1},
        {label: '父母健在', value: 1},
        {label: '单亲家庭', value: 2},
        {label: '父亲健在', value: 3},
        {label: '母亲健在', value: 4},
        {label: '父母均离世', value: 5}
      ],
      parentState: -1,

      // 微信认证总状态
      wechatTotalStateArray: [
        {label: '不限', value: -1},
        {label: '未提交', value: 0},
        {label: '待审核', value: 1},
        {label: '已通过', value: 2},
        {label: '未通过', value: 3},
      ],
      wechatTotalState: -1,

      //通过码
      throughCodeArray:[
        {label:'不限', value: ''}
      ],
      throughCode: '',

      // 跟进人
      userCustomerServiceStateArray: [
        {label: '不限', value: -1},
        {label: '未添加', value: 0},
        {label: '已添加', value: 1},
        {label: '已删除', value: 2}
      ],
      userCustomerServiceState: -1,
      customerDisable: true,
      wechatIdArray: [
        {label:'不限', value: ''}
      ],
      wechatIdList: [],
      wechatId: '',

      // 认证情况
      authStateArray: [
        {label: '不限', value: -1},
        {label: '房屋认证', value: 1},
        {label: '职业认证', value: 2},
        {label: '学历认证', value: 3},
        {label: '车辆认证', value: 4},
        {label: '视频认证', value: 5}
      ],
      authState: -1,

      // 进入情况
      enterStateArray: [
        {label: '不限', value: -1},
        {label: '已进入', value: 1},
        {label: '未进入', value: 2}
      ],
      enterState: -1,

      inviteSpecialStateArray: [
        {label: '不限', value: -1},
        {label: '是', value: 1},
        {label: '否', value: 0}
      ],
      inviteSpecialState: -1,

      // 家乡城市
      homeProvince: '',
      homeCity: '',
      resetArea: false,

      //现居城市
      province:'',
      city: [],

      //籍贯
      proNativeCode:'',
      cityNativeCode: [],


      // 信息审核状态
      resumeStateArray: [
        {label: '不限', value: -1},
        {label: '未提交', value: 0},
        {label: '待审核', value: 1},
        {label: '审核通过', value: 2},
        {label: '审核不通过', value: 3}
      ],
      resumeState: -1,


      //注册时间
      startTime: '',
      endTime: '',
      isChecked: false,

      //跟进时间
      customerStartTime: '',
      customerEndTime: '',
      isCustomerChecked: true,

      //登录时间
      loginStartTime: '',
      loginEndTime: '',
      isLoginChecked: true,

      //年龄
      ageTypeArray: [
        {label: '年龄段', value: 1},
        {label: '生日时间', value: 2},
        {label: '自定义年龄', value: 3}
      ],
      ageType: 1,
      // 年龄段
      ageGroupArray: [
        {label: '不限', value: -1},
        {label: '70后', value: 1970},
        {label: '75后', value: 1975},
        {label: '80后', value: 1980},
        {label: '85后', value: 1985},
        {label: '90后', value: 1990},
        {label: '95后', value: 1995},
        {label: '00后', value: 2000}
      ],
      ageGroup: -1,
      // 生日时间
      birthdayStartTime: '',
      birthdayEndTime: '',
      isBirthdayChecked: true,
      // 自定义年龄范围
      startAge: '',
      endAge: '',

      //搜索
      searchTypeArray: [
        {label : '手机号', value : 1},
        {label : '昵称', value : 2},
        {label : '用户ID', value : 3},
        {label : '用户日志', value : 4},
        {label : '用户小记', value : 5},
        {label : '身份实名', value : 6},
        {label : '身份证号', value : 9},
        {label : '自我介绍', value : 7},
        {label : '行业、职能、职位', value : 8},
      ],
      searchType: 3,
      searchValue: '',

      //刷新组
      colList: ['注册时间', '登陆时间', '手持身份照片', '头像', '用户信息', '小记', '跟进人', '基本信息', '择偶标准', '用户日志', '信息审核状态', '自我介绍', '信息标签', '认证情况', '身份认证总状态', '微信认证总状态', '微信信息', '通过码处展示红娘', '牵线处展示红娘', '操作'],
      checkColList: [],

      pageDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,
      listLoading: false,
      searchLoading: false,

      dataSummary: [],

      idArray: [],
      updateLoading: false,

      limitState: false,
      sort: 1,

    }
  },
  methods: {

    educationChange() {
      if(this.education[0] == -1) {
        this.education.splice(0, 1)
      }else if(this.education.indexOf(-1) > -1) {
        this.education = [-1]
      }
      // console.log(this.education)
    },

    ageTypeChange() {
      this.ageGroup = -1;
      this.birthdayStartTime = '';
      this.birthdayEndTime = '';
      this.isBirthdayChecked = true;
      this.startAge = '';
      this.endAge = '';
    },

    ageGroupChange(val) {
      if (val == -1) {
        this.birthdayStartTime = '';
        this.birthdayEndTime = '';
      } else {
        this.birthdayStartTime = val + '-01-01';
        this.birthdayEndTime = (val + 4) + '-12-31';
      }
    },

    startAgeChange(val) {
      if (val) {
        let date = new Date()
        let y = date.getFullYear()
        let m = date.getMonth() + 1
        let d = date.getDate()
        this.birthdayEndTime = (y-val) + '-' + (m<10?'0'+m:m) + '-' + (d<10?'0'+d:d)
      } else {
        this.birthdayEndTime = ''
      }
    },

    endAgeChange(val) {
      if (val) {
        let date = new Date()
        let y = date.getFullYear()
        let m = date.getMonth() + 1
        let d = date.getDate()
        this.birthdayStartTime = (y-val) + '-' + (m<10?'0'+m:m) + '-' + (d<10?'0'+d:d)
      } else {
        this.birthdayStartTime = ''
      }
    },

    // 家乡城市
    getArea(el) {
      this.homeProvince = el.prov;
      this.homeCity = el.city;
    },

    // 仙居城市
    getNowArea(el) {
      this.province = el.prov;
      this.city = el.city;
    },

    // 籍贯
    getNativeArea(el) {
      this.proNativeCode = el.prov;
      this.cityNativeCode = el.city;
    },

    // 月收入list
    getIncome() {
      let arr = [];
      for(let i = 2; i <= 50; i++) {
        arr.push({label : i + 'k', value : i})
      }
      this.salaryMinArray = this.salaryMinArray.concat(arr);
      this.salaryMaxArray = this.salaryMaxArray.concat(arr);
    },

    // 身高
    getHeight() {
      let arr = [];
      for(let i = 145; i <= 200; i++) {
        arr.push({label : i + 'cm', value : i})
      }
      this.heightMinArray = this.heightMinArray.concat(arr);
      this.heightMaxArray = this.heightMaxArray.concat(arr);
    },

    // 体重
    getWeight() {
      let arr = [];
      for(let i = 40; i <= 80; i++) {
        arr.push({label : i + 'kg', value : i})
      }
      this.weightMinArray = this.weightMinArray.concat(arr);
      this.weightMaxArray = this.weightMaxArray.concat(arr);
    },

    getTime(val) {
      this.startTime = val[0];
      this.endTime = val[1];
    },
    getCheck(val) {
      this.isChecked = val
    },

    getCustomerTime(val) {
      this.customerStartTime = val[0];
      this.customerEndTime = val[1];
    },
    getCustomerCheck(val) {
      this.isCustomerChecked = val
    },

    getLoginTime(val) {
      this.loginStartTime = val[0];
      this.loginEndTime = val[1];
    },
    getLoginCheck(val) {
      this.isLoginChecked = val
    },

    getBirthdayTime(val) {
      this.birthdayStartTime = val[0];
      this.birthdayEndTime = val[1];
    },
    getBirthdayCheck(val) {
      this.isBirthdayChecked = val
    },


    getSearchType(e) {
      this.searchType = e;
      // console.log(e)
    },
    getSearchValue(e) {
      this.searchValue = e;
      // console.log(e)
    },
    // 展示表格的列
    colListChange(val) {
      this.checkColList = val;
    },
    // 重置参数
    refreshParam() {
      this.resetArea = !this.resetArea;
      this.isChecked = false;
      this.isCustomerChecked = true;
      this.isLoginChecked = true;
      this.isBirthdayChecked = true;
      this.customerDisable = true;
      this.sex = 2;
      this.overallAuthState = -1;
      this.marryState = -1;
      this.marryTime = -1;
      this.education = [-1];
      this.salaryMin = -1;
      this.salaryMax = -1;
      this.heightMin = -1;
      this.heightMax = -1;
      this.weightMin = -1;
      this.weightMax = -1;
      this.childState = -1;
      this.parentState = -1;
      this.wechatTotalState = -1;
      this.userCustomerServiceState = -1;
      this.authState = -1;
      this.enterState = -1;
      this.resumeState = -1;
      this.ageGroup = -1;
      this.inviteSpecialState = -1;
      this.ageType = 1;
      this.sort = 1;
      this.wechatId = '';
      this.homeProvince = '';
      this.province = '';
      this.homeCity = '';
      this.city = '';
      this.proNativeCode = '';
      this.cityNativeCode = '';
      this.throughCode = '';
      this.searchValue = '';
      this.limitState = false;
      setTimeout(()=> {
        this.getPage(true);
      }, 500)
    },
    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },

    //排序
    sortChange(column) {
      if(column.prop == 'createTime') {
        if(column.order == 'descending') {
          this.sort = 1;
        } else if(column.order == 'ascending') {
          this.sort = 2;
        }
      } else if(column.prop == 'loginTime') {
        if(column.order == 'descending') {
          this.sort = 3;
        } else if(column.order == 'ascending') {
          this.sort = 4;
        }
      }
      this.getPage();
    },

    //获取选中id
    selsChange(sels) {
      this.idArray = sels.map(item => item.userId);
    },

    //全选
    selsAll(column, event) {
      if(column.type == 'selection') {
        let array = this.idArray;
        if(array.length == this.pageDataList.length) {
          array = [];
        }
        this.pageDataList.forEach(item => {
          if(array.indexOf(item.userId) === -1) {
            this.$refs.multipleTableRef.toggleRowSelection(item);
          }
        })
      }
    },

    getPage(reset) {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['sex'] = this.sex;
      param['sort'] = this.sort;
      param['overallAuthState'] = this.overallAuthState;
      param['marryState'] = this.marryState;
      param['marryTime'] = this.marryTime;
      if(this.education[0] != -1) {
        param['education'] = this.education.toString();
      }
      param['salaryMin'] = this.salaryMin;
      param['salaryMax'] = this.salaryMax;
      param['childState'] = this.childState;
      param['heightMin'] = this.heightMin;
      param['heightMax'] = this.heightMax;
      param['heightMax'] = this.heightMax;
      param['weightMin'] = this.weightMin;
      param['weightMax'] = this.weightMax;
      param['parentState'] = this.parentState;
      param['wechatTotalState'] = this.wechatTotalState;
      param['throughCode'] = this.throughCode;
      param['userCustomerServiceState'] = this.userCustomerServiceState;
      param['wechatId'] = this.wechatId;
      param['authState'] = this.authState;
      param['enterState'] = this.enterState;
      param['homeProvince'] = this.homeProvince;
      param['homeCity'] = this.homeCity;
      param['province'] = this.province;
      if(this.city[0] != '不限') {
        param['city'] = this.city.toString();
      }
      param['proNativeCode'] = this.proNativeCode;
      if(this.cityNativeCode[0] != '不限') {
        param['cityNativeCode'] = this.cityNativeCode.toString();
      }
      param['resumeState'] = this.resumeState;
      param['startTime'] = this.startTime;
      param['endTime'] = this.endTime;
      param['customerStartTime'] = this.customerStartTime;
      param['customerEndTime'] = this.customerEndTime;
      param['loginStartTime'] = this.loginStartTime;
      param['loginEndTime'] = this.loginEndTime;
      param['birthdayStartTime'] = this.birthdayStartTime;
      param['birthdayEndTime'] = this.birthdayEndTime;
      param['searchType'] = this.searchType;
      param['searchValue'] = this.searchValue;
      param['inviteSpecialState'] = this.inviteSpecialState;
      param['limitState'] = this.limitState?1:0;

      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getUserPageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.pageDataList.map(item => {
            if(item.userTagList) {
              item.userTagListMe = []
              item.userTagListTa = []
              for(let i=0; i<item.userTagList.length; i++) {
                if(item.userTagList[i].type == 1) {
                  item.userTagListMe.push(item.userTagList[i])
                }else {
                  item.userTagListTa.push(item.userTagList[i])
                }
              }
            }
          })
          this.totalRow = result['total'];
          this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch((response) => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },

    showImg(img) {
      let imgList = []
      imgList.push(img)
      ImgViewer.open({
        imgList: imgList
      })
    },

    userInfoDialog(row) {
      Dialog.open({
        title: '',
        component: userListInfoDialog,
        data: {
          userId: row.userId,
          width: '800px',
        },
      })
    },

    toggleSelection(row, column, cell, event) {
      if(column.type == 'selection') {
        this.$refs.multipleTableRef.toggleRowSelection(row)
      }

      //更新用户日志
      if(column.label == '用户日志') {
        Dialog.open({
          title: '用户日志',
          component: UserLogDialog,
          data: {
            id: row.userId
          },
          close: () => {
            row['userLogList'] = JSON.parse(sessionStorage.getItem('userLog'));
          }
        })
      }

      //小记
      if(column.label == '小记') {
        Dialog.open({
          title: '小记',
          component: UserRemarkDialog,
          data: {
            id: row.userId
          },
          close: () => {
            row['userSmallRemarkList'] = JSON.parse(sessionStorage.getItem('userRemark'));
          }
        })
      }

      if(column.label == '今天/昨天/前天/总共(发起招呼)') {
        Dialog.open({
          title: '用户发起招呼数量列表',
          component: GreetingDateNum,
          data: {
            userId: row.userId,
            type: 1,
            width: '600px'
          },
          close: () => {

          }
        })
      }

    },

    // //用户异常ip列表
    // openIpCityDialog(idx, row) {
    //   Dialog.open({
    //     title: '用户【' + row.nickName + '】异常ip列表',
    //     component: ipCityAbnormalDialog,
    //     data: {
    //       id: row.userId,
    //       width: '600px',
    //       ipState: row.ipState,
    //     },
    //     confirm: (result) => {
    //       this.pageDataList[idx]['ipState'] = result.state
    //     }
    //   })
    // },

    //获取通过码、跟进人
    getCommon() {
      getFormData(getCommonSysParam).then((data)=>{
          if( data.code == 200) {
            // console.log(data)
            let wechatList = data.data.customerServiceWechatList
            let codeList = data.data.wechatThroughCodeList
            let arr_w = []
            wechatList.map(item => {
              let obj = {}
              obj.label = item;
              obj.value = item;
              arr_w.push(obj)
            })
            this.wechatIdList = arr_w
            this.wechatIdArray = this.wechatIdArray.concat(arr_w)
            let arr_c = []
            codeList.map(item => {
              let obj = {}
              obj.label = item;
              obj.value = item;
              arr_c.push(obj)
            })
            this.throughCodeArray = this.throughCodeArray.concat(arr_c)
          }
      })
    },

    changeUserCustomer() {
      this.wechatId = '';
      if(this.userCustomerServiceState != 1) {
        this.isCustomerChecked = true
        this.customerDisable = true
      }else {
        this.customerDisable = false
      }
    },

    // 编辑跟进人
    editCustomer(row) {
      let userListForm = Object.assign({}, row);
      Dialog.open({
        title: '添加微信记录',
        component: updateCustomerDialog,
        data: {
          userListForm: userListForm,
          wechatIdArray: this.wechatIdList,
          width: '500px'
        },
        confirm: (result) => {
          this.getPage()
        }
      })
    },

    //展示、隐藏、注销
    updateResumeDelState(idx, row, state) {
      this.$confirm('确认' + (state == 1 ? '隐藏' : '显示') + '用户【' + row.nickName + '】简历？').then(() => {
        this.pageDataList[idx]['delLoading'] = true
        let param = {};
        param['id'] = row.userId;
        param['del'] = state;
        let _this = this;
        postFormData(updateResumeDelState, param).then(function(data) {
          let code = data.code;
          let msg = data.msg;
          if(code == 200) {
            _this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'success'
            });
            _this.pageDataList[idx]['isDel'] = state;
          } else {
            _this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'warning'
            });
          }
          _this.pageDataList[idx]['delLoading'] = false;
        })
            .catch(function(response) {
              _this.pageDataList[idx]['delLoading'] = false;
            })
      })
    },


  },
  mounted() {
    this.$nextTick(function() {
      this.checkColList = this.colList;
    })
    this.getIncome();
    this.getHeight();
    this.getWeight();
    this.getCommon();
    this.getPage();
  }
}
</script>

<style scoped>
.tag-title {
  font-size: 12px;
  margin-bottom: 4px;
}
.tap-item {
  margin: 0 4px 4px 0;
  /*display: inline-block;*/
}
</style>
